class StickyButton extends HTMLElement {

  constructor() {
    super();
    this.button = this.querySelector('.sticky-element');
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('DOMContentLoaded', this.updatePosition.bind(this));
    window.addEventListener('resize', this.updatePosition.bind(this));
  }

  updatePosition() {
    const self = this;
    let clonedButton = this.button.cloneNode(true);
    clonedButton.classList.add('sticky')
    this.appendChild(clonedButton)
    const stickyButton = this.querySelector('.sticky-element.sticky')
    if (!stickyButton) return;
    const deviceWidth = new DeviceWidth();
    if (deviceWidth.isDesktop) return;
    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0
    });

    observer.observe(this);

    function handleIntersection(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          stickyButton.classList.remove('fade-in')
        } else {
          stickyButton.classList.add('fade-in');
        }
      });
    }
  }


}

customElements.define('sticky-button', StickyButton);